// Mui
import { styled } from "@mui/system";
import { Chip } from "@mui/material";

// Utils
import { shouldForwardProp } from "utils";

type OptionsPillProps = {
    filterId: "function" | "hierarchy" | "team";
    type?: string;
    counter?: number;
};

export const FilterOptionsPill = styled(Chip, {
    shouldForwardProp: (prop) => shouldForwardProp<OptionsPillProps>(["filterId", "type", "counter"], prop),
})<OptionsPillProps>(({ filterId, type, counter, theme }) => ({
    backgroundColor:
        filterId === "team"
            ? theme.palette.primary.light
            : filterId === "hierarchy"
            ? theme.palette.others.lightSkyBlue
            : filterId === "function"
            ? type === "TECHNOLOGY"
                ? theme.palette.others.limeGreen
                : type === "NON_EXECUTIVE"
                ? theme.palette.others.goldenYellow
                : type === "FINANCE"
                ? theme.palette.others.brightOrange
                : type === "MARKETING"
                ? theme.palette.others.neonSkyBlue
                : type === "LEADERSHIP"
                ? theme.palette.others.darkGrey
                : type === "HR"
                ? theme.palette.others.darkOrange
                : type === "REVENUE_SALES"
                ? theme.palette.others.skyBlue
                : type === "MANAGEMENT"
                ? theme.palette.others.lavenderPurple
                : type === "OPERATIONS"
                ? theme.palette.others.brightPink
                : type === "NON_EXECUTIVE_LEADERSHIP"
                ? theme.palette.others.warmBeige
                : theme.palette.others.grey
            : theme.palette.others.grey,
    height: 28,
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    margin: theme.spacing(0.5),
    paddingLeft: theme.spacing(0.5),
    "& .MuiChip-label": {
        maxWidth: 160,
        textOverflow: "ellipsis",
        whiteSpace: "pre",
        overflow: "hidden",
        fontSize: 12,
        color: type === "LEADERSHIP" ? theme.palette.text.alt : theme.palette.common.black,
        letterSpacing: "1.25px",
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
}));
